import React, { useEffect, useLayoutEffect } from "react";
import { useForm } from "react-hook-form";
import InputField from "../../components/form/InputField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import SelectField from "../../components/form/SelectField";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/loading/Loading";
import {
  addAccountCategory,
  editAccountCategory,
  getAccountCategory,
  getAccountTypes,
  unsetAccountCategories,
  unsetAccountTypes,
} from "../../features/accountsSlice";
import { closeModal } from "../../features/modalSLice";
import { useNotification } from "../../components/notification/NotificationContainer";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  addAccountCategorySchema,
  editAccountCategorySchema,
} from "../../schemas";

const AddCategory = ({ edit, id }) => {
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const accountTypes = useSelector((state) => state.accounts.accountTypes);
  const addAccountCategoryLoad = useSelector(
    (state) => state.accounts.load.addAccountCategory
  );

  const category = useSelector(
    (state) => state.accounts.selectedAccountCategory
  );

  const AccountTypesLoad = useSelector(
    (state) => state.accounts.load.getAccountTypes
  );

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { id: "", name: "" },
    resolver: zodResolver(
      edit ? editAccountCategorySchema : addAccountCategorySchema
    ),
  });

  const onSubmit = async (data, e) => {
    e.preventDefault();
    let res;
    try {
      if (!edit) {
        res = await dispatch(addAccountCategory(data));
        if (addAccountCategory.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Account Category added successfuly!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        res = await dispatch(editAccountCategory({ id: id, data }));
        if (editAccountCategory.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Account Category updated successfuly!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    dispatch(getAccountTypes());
    if (edit) {
      dispatch(getAccountCategory(id));
    }
    return () => {
      dispatch(unsetAccountTypes());
      dispatch(unsetAccountCategories());
    };
  }, []);

  useEffect(() => {
    if (category.id) {
      reset({
        id: category.id,
        account_type_id: category.account_type_id,
        name: category.name,
      });
    }
  }, [category]);

  if (AccountTypesLoad) {
    return <Loading />;
  }

  return (
    <div className="overflow-auto">
      <h5 className="text-center  mb-7 text-primary">ADD CATEGORY</h5>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row  min-w-72 sm:min-w-80 lg:min-w-96">
          <InputField
            register={register}
            name="name"
            label="Category"
            errors={errors.name}
            type="text"
          />
        </div>
        <SelectField
          name="account_type_id"
          label="Account Type"
          register={register}
          data={[{ id: "", name: "-- Select Account Type" }, ...accountTypes]}
          errors={errors.account_type_id}
        />
        <ResourseButtons loading={addAccountCategoryLoad} />
      </form>
    </div>
  );
};

export default AddCategory;
